import {BaseCachedService} from './Core/BaseCachedService';

class ProjectStatusService extends BaseCachedService {
    get Url() { return super.Url + "/projectStatuses"; }
    get ModelName() { return "Sample Event Phase"; }
    get PrimaryKeyProperty() { return "sampleEventPhaseId"; }
}

export const service = new ProjectStatusService();

